import Page from "components/Page";

const VerifiedView = () => {
  return (
    <Page title="Join Waboba Supply Chain">
      <div className="p-10">
        <div>
          <h2 className="text-2xl font-bold mb-4">欢迎加入 Waboba 供应链！</h2>
          <p>
            您的申请已通过，您已正式成为我们的供应商。感谢您的信任与支持，期待未来与您的合作共赢！Your
            application has been approved, and you are now officially a
            supplier. Thank you for your trust and support, and we look forward
            to a win-win cooperation with you!
          </p>
          <p>
            如有任何疑问或需要进一步协助，请随时联系我们的供应商管理团队。If you
            have any questions or need further assistance, please feel free to
            contact our supplier management team.
          </p>
        </div>
      </div>
    </Page>
  );
};

export default VerifiedView;
